<template>
  <div class="row" style="height: 100vh; overflow-y: hidden">
    <!-- Start of Trading view -->
    <div
      v-show="btnToggles.daily"
      :class="openWidget ? chartWidthPercentage : 'col-grow shadow-1'"
    >
      <div class="col">
        <TradingView
          @selectedSymbol="changeSelectedSymbol($event)"
          :symbol="selectedSymbol"
          :indicators="
            (widgetbarButtonFilter == 'meanReversalSignal' ||
              widgetbarButtonFilter == 'divergenceSignal') &&
            indicatorsList
          "
          :footerHeight="footerRef?.offsetHeight"
          :toggles="toggles"
          :candleStickData="candleStickData"
          :buySellTargetData="myStockChartData"
          :signalTypedata="chartData"
          :footerScreen="footerScreen"
          :footerFullHeight="footerFullHeight"
          :heightWhenFooterisOn="heightWhenFooterisOn"
          :isMySignalSignal="widgetbarButtonFilter == 'mySignals'"
          :isSignalType="
            widgetbarButtonFilter == 'priceActionSignal' ||
            widgetbarButtonFilter == 'meanReversalSignal' ||
            widgetbarButtonFilter == 'divergenceSignal' ||
            widgetbarButtonFilter == 'dailyBuySignal'
              ? true
              : false
          "
          :signaltype="buttonBuyOrSell"
          :timePeriod="timePeriod"
          :isThisStock="isThisStock == -1 ? false : true"
        />
      </div>
      <div
        ref="footerRef"
        class="text-right q-pr-sm row justify-end q-px-xs gt-xs"
        v-if="isThisStock != -1"
      >
        <!-- Start of Footer -->
        <div
          class="col-9 col-grow text-bold row gt-xs"
          v-if="!footerFullHeight"
        >
          <div
            class="text-caption text-left text-primary q-pa-xs"
            v-if="!footerScreen"
          >
            Expand to see Basic Info, Broker Pro, Level Alert and many more.
          </div>
          <div v-else class="q-gutter-xs">
            <q-btn
              size="xs"
              color="blue-4"
              label="Large"
              @click="heightWhenFooterisOn = '35vh'"
              :outline="heightWhenFooterisOn != '35vh'"
            />

            <q-btn
              size="xs"
              color="blue-4"
              label="Small"
              @click="heightWhenFooterisOn = '50vh'"
              :outline="heightWhenFooterisOn != '50vh'"
            />
          </div>
        </div>
        <div class="col-3 row justify-end q-gutter-x-sm q-pa-xs">
          <div>
            <span
              style="cursor: pointer"
              class="text-white"
              @click="
                footerScreen = !footerScreen;
                if (!footerScreen) footerFullHeight = false;
              "
            >
              <span :class="footerScreen ? 'text-red' : 'text-secondary'">
                {{ footerScreen ? "Collapse" : "Expand" }}
              </span>
              <q-tooltip v-if="!footerScreen">
                Expand to see Basic Info, Broker Pro, Level Alert, Floorsheet
                and many more.</q-tooltip
              >
            </span>
          </div>

          <div
            style="cursor: pointer"
            @click="
              footerFullHeight = !footerFullHeight;
              if (footerFullHeight == true) footerScreen = true;
            "
          >
            <q-icon
              size="sm"
              :name="footerFullHeight ? 'fullscreen_exit' : 'fullscreen'"
            >
              <q-tooltip v-if="!footerScreen || !footerFullHeight"
                >Extra Large View</q-tooltip
              >
            </q-icon>
          </div>
        </div>
      </div>
      <div
        :style="
          footerFullHeight
            ? 'height: 91vh; overflow: scroll'
            : `height: ${footerHeightMap[heightWhenFooterisOn]}; overflow: scroll`
        "
        v-if="(footerScreen || footerFullHeight) && isThisStock != -1"
      >
        <ChartStockWiseTabbed
          class="q-my-sm"
          style="padding: 1px; margin: 1px"
          :symbol="selectedSymbol"
          :isChartFooter="true"
        />
      </div>
    </div>
    <!-- End of Trading View -->

    <!-- Start of Widgetbar -->
    <div
      :class="openWidget ? widgetWidthPercentage : 'col-shrink shadow-1 gt-sm'"
    >
      <div class="row">
        <!-- Start of widgetbar body -->
        <!-- This is where content be -->
        <div
          class="col-md-10 col-xs-grow col-md-grow"
          v-show="openWidget"
          style="max-height: 100; overflow: hidden"
        >
          <div>
            <!-- Start of empty cart -->
            <q-card flat bordered class="q-ml-xs shadow-9">
              <div class="row">
                <q-btn
                  size="sm"
                  class="q-ma-xs col-grow"
                  :outline="widgetWidth != '25'"
                  color="blue-4"
                  label="Small View"
                  @click="widgetWidth = '25'"
                ></q-btn>
                <q-btn
                  size="sm"
                  class="q-ma-xs col-grow gt-sm"
                  :outline="widgetWidth != '35'"
                  color="blue-4"
                  label="Large View"
                  @click="widgetWidth = '35'"
                ></q-btn>
                <q-btn
                  size="sm"
                  class="q-ma-xs col-grow gt-sm"
                  :outline="widgetWidth != '50'"
                  color="blue-4"
                  label="Extra Large View"
                  @click="widgetWidth = '50'"
                ></q-btn>
                <q-btn
                  size="sm"
                  class="q-ma-xs col-grow gt-sm"
                  :outline="widgetWidth != '60'"
                  color="blue-4"
                  label="Very Large View"
                  @click="widgetWidth = '60'"
                ></q-btn>
              </div>
              <!-- <q-btn size="sm" label="60 %" @click="widgetWidth='60'"></q-btn> -->
            </q-card>
            <!-- End of empty cart -->

            <!-- Start of close turnover volume status -->
            <q-card flat bordered class="q-ml-xs q-my-xs">
              <SymbolInfo
                :symbol="selectedSymbol"
                :selectedIndexClosePriceData="selectedIndexClosePriceData"
              />
            </q-card>
            <!-- End of close turnover volume status -->
            <q-scroll-area style="height: 84vh">
              <PackageAuth v-if="widgetbarButtonFilter != 'sectorlist'">
                <template #authorized-content>
                  <div class="row">
                    <!-- My Signals -->
                    <div
                      v-if="widgetbarButtonFilter == 'mySignals'"
                      class="col-12 q-ml-xs"
                    >
                      <MySignalList
                        @chartSymbol="
                          (eventSymbol) => {
                            selectedSymbol = eventSymbol;
                          }
                        "
                        @emitChartData="
                          (eventData) => {
                            myStockChartData = eventData;
                          }
                        "
                      />
                    </div>

                    <!-- Daily Buy Signals -->
                    <ListCard
                      class="q-ml-xs"
                      :name="'Buy Signal'"
                      v-if="widgetbarButtonFilter == 'dailyBuySignal'"
                      :data="buyWeeklyData"
                      :weekly="true"
                      :type="'buy_confirm'"
                      :loading="false"
                      :activeSymbol="selectedSymbol"
                      @clickSymbol="selectedSymbol = $event"
                      :btnSizeSm="false"
                    />
                    <!-- Daily Sell signals -->
                    <ListCard
                      class="q-ml-xs"
                      :name="'Sell Signal'"
                      v-show="widgetbarButtonFilter == 'dailySellSignal'"
                      :data="sellWeeklyData"
                      :weekly="true"
                      :type="'sell_confirm'"
                      :loading="false"
                      :activeSymbol="selectedSymbol"
                      @clickSymbol="selectedSymbol = $event"
                      :btnSizeSm="false"
                    />
                    <!-- CandelStick Map -->
                    <q-card
                      flat
                      bordered
                      class="q-ml-xs"
                      v-if="widgetbarButtonFilter === 'candleStick'"
                    >
                      <CandleStickChart
                        @chartSymbol="
                          (eventSymbol) => {
                            selectedSymbol = eventSymbol;
                          }
                        "
                        @chartTimePeriod="
                          (eventTimePeriod) => {
                            timePeriod = eventTimePeriod;
                          }
                        "
                      />
                    </q-card>

                    <!-- Stock CandelStick Map  -->
                    <q-card
                      flat
                      bordered
                      class="q-ml-xs"
                      v-if="widgetbarButtonFilter === 'stockCandleSticks'"
                    >
                      <StockCandleStickCharts
                        :symbol="selectedSymbol"
                        @child-event="handleChildEvent"
                      />
                    </q-card>

                    <!-- Price Action  -->
                    <ChartPriceActionSignal
                      class="q-ml-xs"
                      v-if="widgetbarButtonFilter == 'priceActionSignal'"
                      @chartSymbol="
                        (eventSymbol) => {
                          selectedSymbol = eventSymbol;
                        }
                      "
                      @buttonBuyOrSell="
                        (eventBuySell) => {
                          buttonBuyOrSell = eventBuySell;
                        }
                      "
                      @emitChartData="
                        (eventData) => {
                          chartData = eventData;
                        }
                      "
                    />
                    <!-- Mean Reversal -->
                    <ChartMeanReversalSignal
                      class="q-ml-xs"
                      v-if="widgetbarButtonFilter == 'meanReversalSignal'"
                      @indicators="(e) => (indicatorsList = e)"
                      @chartSymbol="
                        (eventSymbol) => {
                          selectedSymbol = eventSymbol;
                        }
                      "
                      @buttonBuyOrSell="
                        (eventBuySell) => {
                          buttonBuyOrSell = eventBuySell;
                        }
                      "
                      @emitChartData="
                        (eventData) => {
                          chartData = eventData;
                        }
                      "
                    />
                    <!-- Divergence Signals -->
                    <ChartDivergenceSignal
                      class="q-ma-sm"
                      v-if="widgetbarButtonFilter == 'divergenceSignal'"
                      @indicators="(e) => (indicatorsList = e)"
                      @chartSymbol="
                        (eventSymbol) => {
                          selectedSymbol = eventSymbol;
                        }
                      "
                      @buttonBuyOrSell="
                        (eventBuySell) => {
                          buttonBuyOrSell = eventBuySell;
                        }
                      "
                      @emitChartData="
                        (eventData) => {
                          chartData = eventData;
                        }
                      "
                    />

                    <!-- Bulk Transaction -->
                    <q-card
                      flat
                      bordered
                      class="q-ml-xs full-width"
                      v-if="widgetbarButtonFilter === 'bulkTnx'"
                    >
                      <BulkTransaction
                        class="full-width"
                        @chartSymbol="
                          (eventSymbol) => {
                            selectedSymbol = eventSymbol;
                          }
                        "
                      />
                    </q-card>

                    <!-- Player Favourite -->
                    <q-card
                      flat
                      bordered
                      class="q-ml-xs full-width"
                      v-if="widgetbarButtonFilter === 'playerFavourite'"
                    >
                      <PlayerFavourite
                        @chartSymbol="
                          (eventSymbol) => {
                            selectedSymbol = eventSymbol;
                          }
                        "
                      />
                    </q-card>

                    <!-- Probable Circuit List -->
                    <q-card
                      flat
                      bordered
                      class="q-ml-xs full-width"
                      v-if="widgetbarButtonFilter === 'probableCircuitList'"
                    >
                      <ProbableCircuitList
                        @chartSymbol="
                          (eventSymbol) => {
                            selectedSymbol = eventSymbol;
                          }
                        "
                      />
                    </q-card>

                    <!-- Circuit Range-->
                    <q-card
                      flat
                      bordered
                      class="q-ml-xs full-width"
                      v-if="widgetbarButtonFilter === 'circuitRange'"
                    >
                      <CircuitRange
                        @chartSymbol="
                          (eventSymbol) => {
                            selectedSymbol = eventSymbol;
                          }
                        "
                      />
                    </q-card>

                    <!-- Broker Favourite-->
                    <q-card
                      flat
                      bordered
                      class="q-ml-xs full-width"
                      v-if="widgetbarButtonFilter === 'brokerFavourite'"
                    >
                      <BrokerFavourite
                        @chartSymbol="
                          (eventSymbol) => {
                            selectedSymbol = eventSymbol;
                          }
                        "
                      />
                    </q-card>

                    <!-- Accumulation Distribution-->
                    <q-card
                      flat
                      bordered
                      class="q-ml-xs full-width"
                      v-if="
                        widgetbarButtonFilter === 'accumulationDistribution'
                      "
                    >
                      <AccumulationDistribution
                        @chartSymbol="
                          (eventSymbol) => {
                            selectedSymbol = eventSymbol;
                          }
                        "
                      />
                    </q-card>

                    <!-- Fundamental Scan Pro-->
                    <q-card
                      flat
                      bordered
                      class="q-ml-xs full-width"
                      v-if="widgetbarButtonFilter === 'fundamentalScan'"
                    >
                      <FundamentalScan
                        :widgetWidth="widgetWidth"
                        @chartSymbol="
                          (eventSymbol) => {
                            selectedSymbol = eventSymbol;
                          }
                        "
                      />
                    </q-card>
                  </div>
                </template>
              </PackageAuth>
              <!-- Sector List -->
              <div
                class="q-ml-xs"
                v-if="widgetbarButtonFilter === 'sectorlist'"
              >
                <q-card flat bordered class="q-pa-xs q-gutter-x">
                  <div
                    class="q-mb-m text-subtitle1 text-weight-medium"
                    :class="$q.dark.mode ? '' : 'text-primary'"
                  >
                    Sector List
                  </div>

                  <q-list class="row justify-center">
                    <q-item
                      style="
                        border-style: ridge;
                        border-width: 1px;
                        padding-top: 4px;
                        border-color: #ccc;
                      "
                      dense
                      class="col-4 q-pl-xs"
                      v-for="item in sectorsListData"
                      :key="item.id"
                      clickable
                      :class="`bg-${getButtonColor(
                        item
                      )} text-${getButtonTextColor(item)} ellipsis`"
                      :color="getButtonColor(item)"
                      :text-color="getButtonTextColor(item)"
                      @click="handleSectorClick(item)"
                    >
                      {{ item.name }}
                      <span
                        class="text-caption q-pl-xs ellipsis"
                        :class="getPercentageChange(item)?.style"
                      >
                        {{ getPercentageChange(item)?.data }}
                      </span>
                    </q-item>
                  </q-list>
                </q-card>
              </div>

              <q-card flat class="q-ml-xs q-my-xs">
                <div>
                  <TopLoosersGainersTrunoverVol
                    v-if="liveStockMarketData.length"
                    :topGainers="topGainers"
                    :topLoosers="topLoosers"
                    :topTurnovers="topTurnovers"
                    :topVolumes="topVolumes"
                    :topTransaction="topTransaction"
                    v-show="
                      widgetbarButtonFilter === 'timeline' ||
                      widgetbarButtonFilter === 'sectorlist'
                    "
                    :selectedSectorId="selectedSectorId"
                    :isMarketOn="isMarketOn"
                    @tableSymbol="changeSelectedSymbol($event)"
                  />
                </div>
              </q-card>
              <!-- Start of StockWiseChartEssential(report and everything about stock) -->
              <!-- v-if="isThisStock >= 0" -->
              <q-card
                v-if="
                  !allSectorsList.map((i) => i.symbol).includes(selectedSymbol)
                "
              >
                <div>
                  <!-- <StockWiseChartEssential
             :widgetWidth="widgetWidth"
             :chartRightBar="true"
             class="q-mb-sm"
             style="padding: 1px; margin: 1px"
             :symbol="selectedSymbol"
           /> -->
                  <ChartStockWiseTabbed
                    class="q-my-sm"
                    style="padding: 1px; margin: 1px"
                    :symbol="selectedSymbol"
                  />
                </div>
              </q-card>
              <!-- End of report and everything about stock -->
            </q-scroll-area>
          </div>
        </div>
        <!-- End of widgetbar body -->

        <!-- Start of widgetbar menu list -->
        <div class="col-md-1 col-xs-shrink col-shrink" style="width: initial">
          <div>
            <!-- Start of Home -->
            <div class="q-pa-xs">
              <q-btn
                size="sm"
                class="row"
                color="blue-5"
                :outline="!openWidget"
                @click="
                  widgetbarButtonFilter == 'sectorlist'
                    ? (openWidget = !openWidget)
                    : (widgetbarButtonFilter = 'sectorlist')
                "
                dense
              >
                <q-icon name="home"></q-icon>
                <q-tooltip
                  anchor="center left"
                  self="center right"
                  :offset="[10, 10]"
                  >Home</q-tooltip
                >
              </q-btn>
            </div>
            <!-- Start of Sector list -->
            <!-- <div class="q-pa-xs row">
            <q-btn
              size="sm"
              color="blue-9"
              @click="
                widgetbarButtonFilter = 'sectorlist';
                openWidget = true;
              "
              dense
              :outline="widgetbarButtonFilter != 'sectorlist'"
            >
              <q-icon name="list_alt"></q-icon>
              <q-tooltip>Sector List</q-tooltip>
            </q-btn>
          </div> -->

            <!-- Start of my signals  -->
            <div class="q-pa-xs">
              <q-btn
                size="sm"
                color="purple-5"
                @click="
                  widgetbarButtonFilter = 'mySignals';
                  openWidget = true;
                "
                dense
                :outline="widgetbarButtonFilter != 'mySignals'"
              >
                <q-icon name="equalizer"></q-icon>
                <q-tooltip
                  anchor="center left"
                  self="center right"
                  :offset="[10, 10]"
                  >My Signals</q-tooltip
                >
              </q-btn>
            </div>
            <!-- Start of daily buy signals -->
            <div class="q-pa-xs">
              <q-btn
                size="sm"
                color="secondary"
                @click="
                  widgetbarButtonFilter = 'dailyBuySignal';
                  openWidget = true;
                "
                dense
                :outline="widgetbarButtonFilter != 'dailyBuySignal'"
              >
                <q-icon name="shopping_cart"></q-icon>
                <q-tooltip
                  anchor="center left"
                  self="center right"
                  :offset="[10, 10]"
                  >Buy Signals</q-tooltip
                >
              </q-btn>
            </div>
            <!-- Start of daily sell signals -->
            <div class="q-pa-xs">
              <q-btn
                size="sm"
                color="negative"
                @click="
                  widgetbarButtonFilter = 'dailySellSignal';
                  openWidget = true;
                "
                dense
                :outline="widgetbarButtonFilter != 'dailySellSignal'"
              >
                <q-icon name="sell"></q-icon>
                <q-tooltip
                  anchor="center left"
                  self="center right"
                  :offset="[10, 10]"
                  >Sell Signals</q-tooltip
                >
              </q-btn>
            </div>
            <!-- Start of candel stick map -->
            <div class="q-pa-xs">
              <q-btn
                size="sm"
                color="indigo"
                @click="
                  widgetbarButtonFilter = 'candleStick';
                  openWidget = true;
                "
                dense
                :outline="widgetbarButtonFilter != 'candleStick'"
              >
                <q-icon name="candlestick_chart"></q-icon>
                <q-tooltip
                  anchor="center left"
                  self="center right"
                  :offset="[10, 10]"
                  >Candlestick Map</q-tooltip
                >
              </q-btn>
            </div>

            <!-- Start of chart candelstick map -->
            <div class="q-pa-xs">
              <q-btn
                size="sm"
                color="pink-10"
                @click="
                  widgetbarButtonFilter = 'stockCandleSticks';
                  openWidget = true;
                "
                dense
                :outline="widgetbarButtonFilter != 'stockCandleSticks'"
              >
                <q-icon name="query_stats"></q-icon>
                <q-tooltip
                  anchor="center left"
                  self="center right"
                  :offset="[10, 10]"
                  >Stock Candlestick Map</q-tooltip
                >
              </q-btn>
            </div>

            <!-- Start of Price action list -->
            <div class="q-pa-xs">
              <q-btn
                size="sm"
                color="purple-5"
                @click="
                  widgetbarButtonFilter = 'priceActionSignal';
                  openWidget = true;
                "
                dense
                :outline="widgetbarButtonFilter != 'priceActionSignal'"
              >
                <q-icon name="candlestick_chart"></q-icon>
                <q-tooltip
                  anchor="center left"
                  self="center right"
                  :offset="[10, 10]"
                  >Price Action Signal</q-tooltip
                >
              </q-btn>
            </div>
            <!-- Start of mean reversional signal -->
            <div class="q-pa-xs">
              <q-btn
                size="sm"
                color="amber-10"
                @click="
                  widgetbarButtonFilter = 'meanReversalSignal';
                  openWidget = true;
                "
                dense
                :outline="widgetbarButtonFilter != 'meanReversalSignal'"
              >
                <q-icon name="airline_stops"></q-icon>
                <q-tooltip
                  anchor="center left"
                  self="center right"
                  :offset="[10, 10]"
                  >Mean Reversal Signal</q-tooltip
                >
              </q-btn>
            </div>
            <!-- Start of Divergence Signal -->
            <div class="q-pa-xs">
              <q-btn
                size="sm"
                color="pink"
                @click="
                  widgetbarButtonFilter = 'divergenceSignal';
                  openWidget = true;
                "
                dense
                :outline="widgetbarButtonFilter != 'divergenceSignal'"
              >
                <q-icon name="alt_route"></q-icon>
                <q-tooltip
                  anchor="center left"
                  self="center right"
                  :offset="[10, 10]"
                  >Divergence Signal</q-tooltip
                >
              </q-btn>
            </div>

            <!-- Start of Circuit Range-->
            <div class="q-pa-xs">
              <q-btn
                size="sm"
                color="brown"
                @click="
                  widgetbarButtonFilter = 'circuitRange';
                  openWidget = true;
                "
                dense
                :outline="widgetbarButtonFilter != 'circuitRange'"
              >
                <q-icon name="trending_up"></q-icon>
                <q-tooltip
                  anchor="center left"
                  self="center right"
                  :offset="[10, 10]"
                  >Circuit Range</q-tooltip
                >
              </q-btn>
            </div>

            <!-- Start of Bulk tnx -->
            <div class="q-pa-xs">
              <q-btn
                size="sm"
                color="purple"
                @click="
                  widgetbarButtonFilter = 'bulkTnx';
                  openWidget = true;
                "
                dense
                :outline="widgetbarButtonFilter != 'bulkTnx'"
              >
                <q-icon name="queue"></q-icon>
                <q-tooltip
                  anchor="center left"
                  self="center right"
                  :offset="[10, 10]"
                  >Bulk Transaction</q-tooltip
                >
              </q-btn>
            </div>

            <!-- Start of Player Favourite -->
            <div class="q-pa-xs">
              <q-btn
                size="sm"
                color="purple-10"
                @click="
                  widgetbarButtonFilter = 'playerFavourite';
                  openWidget = true;
                "
                dense
                :outline="widgetbarButtonFilter != 'playerFavourite'"
              >
                <q-icon name="follow_the_signs"></q-icon>
                <q-tooltip
                  anchor="center left"
                  self="center right"
                  :offset="[10, 10]"
                  >Player Favourite</q-tooltip
                >
              </q-btn>
            </div>

            <!-- Start of Probable Circuit List-->
            <div class="q-pa-xs">
              <q-btn
                size="sm"
                color="deep-purple"
                @click="
                  widgetbarButtonFilter = 'probableCircuitList';
                  openWidget = true;
                "
                dense
                :outline="widgetbarButtonFilter != 'probableCircuitList'"
              >
                <q-icon name="dvr"></q-icon>
                <q-tooltip
                  anchor="center left"
                  self="center right"
                  :offset="[10, 10]"
                  >Probable Circuit List</q-tooltip
                >
              </q-btn>
            </div>

            <!-- Start of Broker Favourite-->
            <div class="q-pa-xs">
              <q-btn
                size="sm"
                color="indigo"
                @click="
                  widgetbarButtonFilter = 'brokerFavourite';
                  openWidget = true;
                "
                dense
                :outline="widgetbarButtonFilter != 'brokerFavourite'"
              >
                <q-icon name="troubleshoot"></q-icon>
                <q-tooltip
                  anchor="center left"
                  self="center right"
                  :offset="[10, 10]"
                  >Broker Favourite</q-tooltip
                >
              </q-btn>
            </div>

            <!-- Start of Accumulation Distribution-->
            <div class="q-pa-xs">
              <q-btn
                size="sm"
                color="indigo-10"
                @click="
                  widgetbarButtonFilter = 'accumulationDistribution';
                  openWidget = true;
                "
                dense
                :outline="widgetbarButtonFilter != 'accumulationDistribution'"
              >
                <q-icon name="exposure"></q-icon>
                <q-tooltip
                  anchor="center left"
                  self="center right"
                  :offset="[10, 10]"
                  >Accumulation Distribution</q-tooltip
                >
              </q-btn>
            </div>

            <!-- Start of FundamentalScan-->
            <div class="q-pa-xs">
              <q-btn
                size="sm"
                color="cyan"
                @click="
                  widgetbarButtonFilter = 'fundamentalScan';
                  openWidget = true;
                "
                dense
                :outline="widgetbarButtonFilter != 'fundamentalScan'"
              >
                <q-icon name="search"></q-icon>
                <q-tooltip
                  anchor="center left"
                  self="center right"
                  :offset="[10, 10]"
                  >Fundamental Scan Pro</q-tooltip
                >
              </q-btn>
            </div>
          </div>
        </div>
        <!-- End of widgetbar menu list -->
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  onMounted,
  ref,
  watchEffect,
  onUnmounted,
  reactive,
  computed,
  watch,
} from "vue";
import { LocalStorage, useQuasar } from "quasar";
import TradingView from "./../../components/Tradingview/TradingView.vue";
import SymbolInfo from "./../../components/SymbolInfo.vue";
import ListCard from "src/components/ListCard.vue";
import ChartStockWiseTabbed from "src/components/MainChartComponent/ChartStockWiseTabbed.vue";
import TopLoosersGainersTrunoverVol from "src/components/TopLoosersGainersTrunoverVol.vue";
import CandleStickChart from "src/components/TradingviewOverView/CandleStick/CandleStickChart.vue";
import StockCandleStickCharts from "src/components/TradingviewOverView/CandleStickChartComponents";
import ChartPriceActionSignal from "src/components/MainChartComponent/ChartPriceActionSignal.vue";
import ChartMeanReversalSignal from "src/components/MainChartComponent/ChartMeanReversalSignal.vue";
import ChartDivergenceSignal from "src/components/MainChartComponent/ChartDivergenceSignal.vue";
import MySignalList from "src/components/MySignal/MySignalList.vue";
import PackageAuth from "src/components/Packages/PackageAuth.vue";
import BulkTransaction from "src/components/TradingviewOverView/BulkTransaction/BulkTransaction.vue";
import PlayerFavourite from "src/components/TradingviewOverView/BulkTransaction/PlayerFavourite.vue";
import ProbableCircuitList from "src/components/TradingviewOverView/BulkTransaction/ProbableCircuitList.vue";
import CircuitRange from "src/components/TradingviewOverView/BulkTransaction/CircuitRange.vue";
import BrokerFavourite from "src/components/TradingviewOverView/BrokerFavourite/BrokerFavouriteChart.vue";
import AccumulationDistribution from "src/components/TradingviewOverView/AccumulationDistribution/AccumulationDistribution.vue";
import FundamentalScan from "src/components/TradingviewOverView/FundamentalScan/FundamentalScan.vue";

import { useStore } from "vuex";
import { useRoute } from "vue-router";
import useCore from "src/use/core";
import useData from "src/use/data";
import useDatav2 from "src/use/datav2";
import useTools from "src/use/tools";
import useUtils from "src/use/utils";

const widgetWidthPercentage = computed(() => {
  if (widgetWidth.value == "25") {
    return "col-md-3";
  } else if (widgetWidth.value == "35") {
    return "col-md-4 shadow-1";
  } else if (widgetWidth.value == "50") {
    return "col-md-6";
  } else {
    return "col-md-7 col-sm-7 shadow-1";
  }
});
const chartWidthPercentage = computed(() => {
  if (widgetWidth.value == "25") {
    return "col-md-9  col-grow";
  } else if (widgetWidth.value == "35") {
    return "col-md-8 shadow-1  col-grow";
  } else if (widgetWidth.value == "50") {
    return "col-md-6 col-md-grow col-xs-12 shadow-1 col-grow";
  } else {
    return "col-md-5 col-sm-8 col-md-grow col-xs-12 shadow-1 col-sm-grow";
  }
  // if (widgetWidth.value) {
  //   return "col-md-6 col-md-grow col-sm-grow col-xs-12 shadow-1";
  // } else {
  //   return "col-md-8 col-grow  col-sm-grow  col-md-grow col-sm-grow shadow-1";
  // }
});
const footerRef = ref(null);

const footerHeight = footerRef.value ? footerRef.value.offsetHeight : 0;

const selectedIndexClosePriceData = ref({});
const getTopGainersLoosers = (res) => {
  return {
    topGainers: res
      .filter((item) => item.percentage_change > 0)
      .sort((b, a) => a.percentage_change - b.percentage_change),
    topLoosers: res
      .filter((item) => item.percentage_change < 0)
      .sort((b, a) => b.percentage_change - a.percentage_change),
  };
};
const getTopTurnOverVolume = (res) => {
  let topTurnovers = res
    .map((item) => {
      return {
        symbol: item.symbol,
        amount: item.amount,
        close: item.close,
      };
    })
    .sort((a, b) => b.amount - a.amount);
  let topVolumes = res
    .map((item) => {
      return {
        symbol: item.symbol,
        volume: item.volume,
        close: item.close,
      };
    })
    .sort((a, b) => b.volume - a.volume);
  return { topTurnovers: topTurnovers, topVolume: topVolumes };
};

const { allStock } = useCore();
const { getAllSectors } = useUtils();
const { buySellWeekly, buySellSearch } = useData();
const { marketSummaryV2 } = useDatav2();
const $store = useStore();
const $route = useRoute();
const $q = useQuasar();
const heightWhenFooterisOn = ref("35vh");
const footerHeightMap = ref({
  "35vh": "60vh",
  "50vh": "45vh",
});

let widgetbarButtonFilter = ref("sectorlist");
let showStastistics = ref("");
const sellWeeklyData = ref([]);
const buyWeeklyData = ref([]);
const symbolConfirm = ref(null);
let selectedSymbol = ref("NEPSE");
let selectedSectorId = ref(null);
let openWidget = ref(true);
const widgetWidth = ref("35");
let footerScreen = ref(false);
let footerFullHeight = ref(false);
const loading = ref(true);
const allSectors = ref([]);
let isThisStock = ref(-1);
const candleStickData = ref([]);
const chartData = ref([]);
const myStockChartData = ref([]);
const liveStockMarketData = ref([]);
const topGainers = ref([]);
const topLoosers = ref([]);
const topTurnovers = ref([]);
const topVolumes = ref([]);
const topTransaction = ref([]);
const isMarketOn = ref(LocalStorage.getItem("isMarketOn"));
const buttonBuyOrSell = ref("");
const indicatorsList = ref([]);
const timePeriod = ref("daily");

const toggles = reactive({
  buySell: false,
  // buySellEarly: false,
  support: false,
  resistance: false,
  trendline: false,
  adjusted: true,
});
const btnToggles = reactive({
  daily: ref(true),
  weekly: ref(false),
  hourly: ref(false),
});

let id;
let intervalIds = [];
const allSectorsList = ref([]);
const sectorsListData = ref([]);
allSectorsList.value = getAllSectors();
sectorsListData.value = getAllSectors();

function loadStockIndexPerforamance(stockOrIndex) {
  intervalIds.forEach((_id) => {
    clearInterval(_id);
  });

  apiHit();
  function apiHit() {
    if (stockOrIndex == "INDEX") {
      marketSummaryV2("index").then((res) => {
        getSectorListData(res.data);

        selectedIndexClosePriceData.value = res.data.find(
          (i) => i.symbol == selectedSymbol.value
        );
      });
    } else if (stockOrIndex == "STOCK") {
      marketSummaryV2("stock").then((res) => {
        selectedIndexClosePriceData.value = res.data.find(
          (i) => i.symbol == selectedSymbol.value
        );
      });
    }
  }
  if (isMarketOn.value) {
    id = setInterval(() => {
      apiHit();
    }, 60000);
    intervalIds.push(id);
  }
}

function changeSelectedSymbol(e) {
  if (selectedSymbol.value != e) {
    selectedSymbol.value = e;
    loadTopGainLooseVolTurnIfIndexAndPerformanceOfSymbols(e);
  }
}

function handleChildEvent(value) {
  candleStickData.value = value;
}

function getMarketStatus() {
  if ($store.state.market.marketStatus) {
    isMarketOn.value = $store.state.market.marketStatus;
  } else {
    $store
      .dispatch("market/marketStatusNew")
      .then(() => (isMarketOn.value = $store.state.market.marketStatus));
  }
}

onMounted(() => {
  LocalStorage.setItem("footer", false);
  footerScreen.value = false;
  footerFullHeight.value = false;
  selectedSectorId.value = null;

  // Set dark theme from localstorage
  let isDarkTheme = LocalStorage.getItem("darkTheme");
  isDarkTheme ? $q.dark.set(true) : $q.dark.set(false);

  if ($route.query.symbol != undefined) {
    selectedSymbol.value = $route.query.symbol;
    loadTopGainLooseVolTurnIfIndexAndPerformanceOfSymbols(selectedSymbol.value);
  } else {
    selectedSymbol.value = $store.state.chartsymbol.chartSymbol || "NEPSE";
    loadTopGainLooseVolTurnIfIndexAndPerformanceOfSymbols(selectedSymbol.value);
  }

  loadBuySellData();
  getMarketStatus();
});

onUnmounted(() => {
  intervalIds.forEach((_id) => {
    clearInterval(_id);
  });
});

function loadBuySellData() {
  buySellWeekly()
    .then((res) => {
      sellWeeklyData.value = filterForListCard(res.data.slice(), "sell");
      buyWeeklyData.value = filterForListCard(res.data.slice(), "buy");
      symbolConfirm.value =
        buyWeeklyData.value?.[0]?.symbol ||
        sellWeeklyData.value?.[0]?.symbol ||
        null;
      loading.value = false;
    })
    .catch((error) => {
      console.log(error);
    });
}

watch(footerScreen, (newVal, oldVal) => {
  if (isThisStock.value != -1) LocalStorage.setItem("footer", newVal);
});

watch(isThisStock, (newVal, oldVal) => {
  if (newVal == -1) {
    footerScreen.value = false;
    footerFullHeight.value = false;
    LocalStorage.setItem("footer", false);
  } else {
    footerScreen.value = LocalStorage.getItem("footer");
  }
});

watchEffect(() => {
  loadTopGainLooseVolTurnIfIndexAndPerformanceOfSymbols(selectedSymbol.value);
  if (widgetbarButtonFilter.value == "mySignals") {
    widgetbarButtonFilter.value = "mySignals";
    showStastistics.value = "showStastistics";
  }
  if (widgetbarButtonFilter.value == "dailyBuySignal") {
    widgetbarButtonFilter.value = "dailyBuySignal";
    showStastistics.value = "showStastistics";
    if (
      buyWeeklyData.value.some((item) => item.symbol === selectedSymbol.value)
    ) {
      buySellSearch(selectedSymbol.value).then((res) => {
        chartData.value = res.data[0];
      });
    }
  }
  if (widgetbarButtonFilter.value == "dailySellSignal") {
    widgetbarButtonFilter.value = "dailySellSignal";
    showStastistics.value = "showStastistics";
  }
});

function loadTopGainLooseVolTurnIfIndexAndPerformanceOfSymbols(symbol) {
  // Symbol may be stock or index.Top gainer looser vol turnover must be according to its sectors.We use allStock to identify symbol belongs to stock or not.
  allStock().then((res) => {
    isThisStock.value = res.data.findIndex((item) => item.symbol == symbol);

    // INDEX and STOCK parameter is sent to hit there respective api, api for index and stock are different.
    if (isThisStock.value == -1) {
      // This is Not Stock.Its index. So, lets find sector of this index.So that we can load top gainers and looser of different sectors.
      findSelectedSectorid(symbol, res.data);
      // Lets load close, point change percentage change, turnover, volume.
      loadStockIndexPerforamance("INDEX");
    } else {
      // Lets load close, point change percentage change, turnover, volume.
      loadStockIndexPerforamance("STOCK");
    }

    function findSelectedSectorid(newValue, stocks) {
      if (newValue != "NEPSE") {
        // newValue is symbol of index.
        // getAllSectors will get sector id name and symbol form utils.
        allSectors.value = getAllSectors();
        selectedSectorId.value = allSectors.value.find(
          (item) => item.symbol == newValue
        ).id;
        loadTopGainerLooserVolumeTurnover(stocks);
      } else {
        selectedSectorId.value = null;
        loadTopGainerLooserVolumeTurnover(stocks);
      }
    }
  });
}
const filterForListCard = (signalData, signalType) => {
  const filterKey = signalType === "buy" ? "buy_date" : "sell_date";
  return signalData
    .slice()
    .map((item) => {
      return { symbol: item.symbol, date: item[filterKey] };
    })
    .filter((item) => {
      return (
        new Date(item.date) >=
        new Date(
          new Date($store.state.market.asOf).setDate(
            new Date($store.state.market.asOf).getDate() - 90
          )
        )
      );
    })
    .sort((a, b) => {
      return new Date(b.date) - new Date(a.date);
    });
};
// if ($store.state.authenticate.isAuthenticated) {
//   getPackageStatus()
//     .then((res) => {
//       packageDetail.value = res.data;
//       // loading.value = false;
//     })
//     .catch((err) => {
//       packageDetail.value = null;
//     });
//   // }
// }
function loadTopGainerLooserVolumeTurnover(stocks) {
  marketSummaryV2("stock").then((res) => {
    let filteredStocksBySectorId = stocks.filter((item) => {
      if (selectedSectorId.value == null || selectedSectorId.value == 25)
        return true;
      return item.sector === selectedSectorId.value;
    });
    liveStockMarketData.value = res.data.filter((i1) =>
      filteredStocksBySectorId.some((i2) => i2.symbol == i1.symbol)
    );

    stockData(liveStockMarketData.value);
  });
}

function stockData(liveStockMarketData) {
  topGainers.value = getTopGainersLoosers(liveStockMarketData).topGainers;
  topLoosers.value = getTopGainersLoosers(liveStockMarketData).topLoosers;
  topTurnovers.value = getTopTurnOverVolume(liveStockMarketData).topTurnovers;
  topVolumes.value = getTopTurnOverVolume(liveStockMarketData).topVolume;
}

const getButtonColor = (item) => {
  return item.symbol === selectedSymbol.value
    ? "primary"
    : $q.dark.mode
    ? "grey-9"
    : "grey-1";
};

const getButtonTextColor = (item) => {
  return item.symbol === selectedSymbol.value
    ? "white"
    : $q.dark.mode
    ? "grey-1"
    : "grey-9";
};

const handleSectorClick = (item) => {
  selectedSymbol.value = item.symbol;
  selectedSectorId.value = item.id;
};

const getSectorListData = (marketData) => {
  sectorsListData.value = allSectorsList.value
    .map((sector) => {
      const matchedData = marketData.find(
        (item) => item.symbol === sector.symbol
      );
      return {
        ...sector,
        percentage_change: matchedData ? matchedData.percentage_change : null,
        amount: matchedData ? matchedData.amount : null,
      };
    })
    .sort((a, b) => {
      // First, ensure "NEPSE" is always at the top
      if (a.symbol === "NEPSE") return -1;
      if (b.symbol === "NEPSE") return 1;

      // Then, sort by percentage_change in ascending order
      if (a.percentage_change === null) return -1; // Null values go to the end
      if (b.percentage_change === null) return 1; // Null values go to the end
      return b.percentage_change - a.percentage_change;
    });
};

const getPercentageChange = (item) => {
  if (!item || typeof item.percentage_change !== "number") {
    return { data: " ", style: "" };
  }

  const percentageChange = item.percentage_change.toFixed(2);

  // Simplify style determination
  const isSelected = item.symbol === selectedSymbol.value;

  const percentageChangeStyle =
    percentageChange > 0
      ? isSelected
        ? "text-green-3"
        : "text-green"
      : percentageChange < 0
      ? isSelected
        ? "text-red-3"
        : "text-red"
      : ""; // Default style for 0% or no change

  return {
    data: ` (${percentageChange} %)`,
    style: percentageChangeStyle,
  };
};
</script>

<style scoped>
:deep(.q-scrollarea__content) {
  width: 100%;
}
</style>
